import $ from 'jquery';

export function makeSorterSelects() {
  $(".sorter-select").each(function() {

    let key = $(this).data("key");

    $(this).on("change", function(e) {
      document.location.hash = "#!" + key + "=" + this.value + "&";
      if (this.value.length) {
        let validCards = $(".nominee-card[data-" + key + "=" + this.value + "]");
        if (validCards.length > 0) {
          $(".nominee-card").hide();
          validCards.show();
        }
      } else {
        $(".nominee-card").show();
      }
    })

    //Check hash
    let hash = document.location.hash.toString();
    let hashBits = hash.split("#!");
    if (hashBits.length > 1) {
      hashBits = hashBits[1].split("&");

      for (let i = 0; i < hashBits.length; i++) {
        let spl = hashBits[i].split("=");
        let hashIndex = spl[0].indexOf(key);
        if (hashIndex >= 0) {
          let value = spl[1];
          $(".sorter-select[data-key='" + key + "']").val(value).trigger("change");
        }
      }

    }


  });
}
